module.exports = __webpack_public_path__ + "static/media/card-5.842187a3.jpf";